import { ProductOrientation } from "./layout/product-orientation";
import { ProductShelfPosition } from "./layout/product-shelf-position";


export class ProductOverride {
    productId: number;
    enabled: boolean;
    hFacings: number | null;
    vFacings: number | null;
    dFacings: number | null;
    categoryFlow: number | null;
    shelfPosition: ProductShelfPosition | null;
    orientation: ProductOrientation | null;
    squeezeFactor: number | null;

    constructor(
        productId: number,
        enabled: boolean | null = null,
        hFacings: number | null = null,
        vFacings: number | null = null,
        dFacings: number | null = null,
        categoryFlow: number | null,
        shelfPosition: ProductShelfPosition | null = null,
        orientation: ProductOrientation | null = null,
        squeezeFactor: number | null = null
    ) {
        this.productId = productId;
        this.enabled = enabled ?? true;
        this.hFacings = hFacings;
        this.vFacings = vFacings;
        this.dFacings = dFacings;
        this.categoryFlow = categoryFlow;
        this.shelfPosition = shelfPosition;
        this.orientation = orientation;
        this.squeezeFactor = squeezeFactor;
    }
}
